"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { getTimeAgo } from "@/helpers/Helpers";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import GroupCardEditActions from "./actions/GroupCardEditActions";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { isAutoGeneratedHandle, isEthereumAddress } from "@/helpers/AllowlistToolHelpers";
export default function GroupCardHeader(t0) {
  const $ = _c(28);
  const {
    group,
    onEditClick,
    userPlaceholder
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== group) {
    t1 = group ? getTimeAgo(new Date(group.created_at ?? "").getTime()) : "";
    $[0] = group;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const timeAgo = t1;
  const rawCreatorHandle = group?.created_by?.handle;
  const fallbackHandle = userPlaceholder ?? "";
  const hasCreatorHandle = Boolean(rawCreatorHandle);
  const creatorHandle = hasCreatorHandle ? rawCreatorHandle : fallbackHandle;
  const profileHref = hasCreatorHandle ? `/${rawCreatorHandle}` : fallbackHandle;
  const shouldTruncateHandle = creatorHandle !== userPlaceholder && (isEthereumAddress(creatorHandle) || isAutoGeneratedHandle(creatorHandle));
  let t2;
  if ($[2] !== group) {
    t2 = <div className="tw-relative tw-h-9 tw-w-9 tw-flex-shrink-0 tw-overflow-hidden tw-rounded-lg tw-ring-1 tw-ring-white/10 tw-shadow-inner tw-shadow-black/40">{group?.created_by.pfp ? <img src={getScaledImageUri(group.created_by.pfp, ImageScale.W_AUTO_H_50)} alt={group?.created_by.handle ? `${group.created_by.handle} profile picture` : "Group creator profile picture"} className="tw-h-full tw-w-full tw-object-cover tw-bg-white/5" loading="lazy" decoding="async" /> : <div className="tw-h-full tw-w-full tw-bg-white/5" />}</div>;
    $[2] = group;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `tw-inline-block tw-text-sm tw-font-semibold ${shouldTruncateHandle ? "tw-max-w-[8rem] tw-truncate" : ""}`;
  let t4;
  if ($[4] !== creatorHandle || $[5] !== t3) {
    t4 = <span className={t3}>{creatorHandle}</span>;
    $[4] = creatorHandle;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== profileHref || $[8] !== t4) {
    t5 = <Link onClick={_temp} href={profileHref} className="tw-relative tw-z-30 tw-inline-flex tw-items-center tw-gap-x-1 tw-text-white tw-no-underline tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-iron-400">{t4}</Link>;
    $[7] = profileHref;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== timeAgo) {
    t6 = timeAgo && <span className="tw-text-xs tw-font-medium tw-text-iron-400">Created {timeAgo}</span>;
    $[10] = timeAgo;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-gap-y-1">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2.5">{t2}{t7}</div>;
    $[15] = t2;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== activeProfileProxy || $[19] !== connectedProfile?.handle || $[20] !== group || $[21] !== onEditClick) {
    t9 = !!connectedProfile?.handle && !activeProfileProxy && onEditClick && group && <GroupCardEditActions group={group} onEditClick={onEditClick} />;
    $[18] = activeProfileProxy;
    $[19] = connectedProfile?.handle;
    $[20] = group;
    $[21] = onEditClick;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-x-3">{t9}</div>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8) {
    t11 = <div className="tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-x-3 tw-gap-y-2.5">{t8}{t10}</div>;
    $[25] = t10;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}
function _temp(e) {
  return e.stopPropagation();
}